<section>
  <p-messages key="ballisticEvidenceListMsg" [closable]="true"></p-messages>
  <div class="card mb-3">
    <div class="card-body">
      <form [formGroup]="listForm">
        <div class="mb-3 w-md-50">
          <label for="dateField" class="form-label required-field fw-bold">Filter by NIBIN Acquisition Date or NIBIN Occurrence Date</label>
          <select #dateFieldSelect id="dateField" class="form-select mb-3" formControlName="DateField" required aria-required="true">
            <option value="">Select date type</option>
            <option value="NIBINAcquisitionDate">NIBIN Acquisition Date</option>
            <option value="NIBINOccurrenceDate">NIBIN Occurrence Date</option>
          </select>
          <div class="invalid-feedback">
            Please select a search type.
          </div>
          <ness-date-range-filter *ngIf="listForm.get('DateField').value != ''" #df [dateFilterVerbiage]="dateFilterVerbiage()" [dateFilterStorageKey]="dateStorageKey"></ness-date-range-filter>
        </div>
        <ng-container *ngIf="isCDSGuest">
          <ness-include-cds-agencies-filter #cf [includeCDSFilterStorageKey]="includeCDSStorageKey" [defaultIncludeCDSValue]="false" tooltipStyleClass="p-tooltip-text-width-400">
            <div class="font-size-sm">
              <div>Check this box to see results from your agency and any agencies with whom your agency has a CDS agreement.</div>
              <br/>
              <div>Your agency has an agreement with the following agencies:</div>
  
              <ul>
                <li *ngFor="let virtualGroup of cdsVirtualGroups">
                  {{virtualGroup.VirtualGroupName}}
                </li>
              </ul>
            
              <div>If you have questions about CDS, please send an email to NESS_Support&#64;atf.gov.</div>
            </div>
          </ness-include-cds-agencies-filter>
        </ng-container>
        <ng-container *removeIfNoPermission="canView">
          <div class="mb-3 w-md-50 mt-5">
            <label for="geoField" class="form-label fw-bold required-field">Filter by Geography or NIBIN Site</label>
            <select #dateFieldSelect id="geoField" class="form-select" formControlName="GeoField" required aria-required="true">
              <option value="">Select filter type</option>
              <option value="Geographic">Geographic (FD, State, etc.)</option>
              <option value="NIBINSite">NIBIN Site</option>
            </select>
            <div class="invalid-feedback" *ngIf="listForm.get('GeoField').invalid">
              Please select a search type.
            </div>
          </div>
          <ness-geographic-filter-region *ngIf="listForm.get('GeoField').value == 'Geographic'" #gfr [geoFilterVerbiage]="'Filtering by Geographic Region:'" [geoFilterStorageKey]="filterStorageKey"></ness-geographic-filter-region>
          <ng-container *ngIf="listForm.get('GeoField').value == 'NIBINSite'">
            <div class="mb-3 w-md-50 mt-5">
              <label class="form-label" for="nibinSiteField">Filter by NIBIN Site</label>
              <div class="input-group mb-2">
                <label class="input-group-text" for="nibinSiteFilter"><span class="visually-hidden">Filter by </span>NIBIN Site</label>
                <ng-container *ngIf="sites$ | async as sites">
                  <p-multiSelect #sitems [(ngModel)]="selectedSites" [ngModelOptions]="{standalone: true}" [options]="sites" optionLabel="ShortName" name="ShortName" placeholder="All" dataKey="ID" inputId="nibinSiteFilter" styleClass="form-select" ariaFilterLabel="Filter by site name" [maxSelectedLabels]="3" [showToggleAll]="false" (onChange)="onSelectSites($event)" [resetFilterOnHide]="true" filterBy="ShortName" [virtualScrollItemSize]="30" [virtualScroll]="true" appendTo="body">
                    <ng-template let-selectedNibinSites pTemplate="selectedItems">
                      <ng-container *ngIf="!selectedSites || selectedSites?.length === 0">All</ng-container>
                      <ng-container *ngIf="selectedSites?.length <= 3">
                        <span *ngFor="let nibinSite of selectedSites; last as isLast">{{nibinSite.ShortName}}<span *ngIf="!isLast">;&nbsp;</span> </span>
                      </ng-container>
                      <ng-container *ngIf="selectedSites?.length > 3">{{ selectedNibinSites.length }} items selected</ng-container>
                    </ng-template>
                  </p-multiSelect>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *removeIfNoPermission="canViewSLFilter">
          <div *ngIf="!hideAgencyTag" class="mb-3 w-md-50 mt-5">
            <label class="form-label fw-bold" for="agenciesFilter">Filter by LE Agency</label>
            <ness-sl-agency-filter #slagencyfilter [userAgencies]="userAgencies" (selectedAgencies)="onSelectedAgencies($event)"></ness-sl-agency-filter>
          </div>
        </ng-container>
        <ng-container *ngIf="!listForm.invalid">
          <div class="mb-3 w-md-50 mt-5">
            <div class="form-label fw-bold">Optional Filters</div>
            <div class="form-check">
              <input id="OnlyFirearms" type="checkbox" formControlName="OnlyFirearms" class="form-check-input" />
              <label for="OnlyFirearms" class="form-check-label">Only Firearms</label>
            </div>
            <div class="form-check">
              <input id="OnlyNIBINLeads" type="checkbox" formControlName="OnlyNIBINLeads" class="form-check-input" />
              <label for="OnlyNIBINLeads" class="form-check-label">Only Evidence with NIBIN Leads</label>
            </div>
          </div>
        </ng-container>
        <div class="mt-5">
          <button type="button" class="btn btn-success mb-2" [disabled]="listForm.invalid || searching" (click)="onSearch()">View List</button>
          <button type="button" class="btn btn-secondary mb-2" [disabled]="searching" (click)="onClear()">Reset</button>
        </div>
      </form>
    </div>
  </div>
  <ness-search-results *ngIf="showResults" [searchResults]="searchResults" [currentUserType]="currentUserType" [loading]="loading" [messageTemplate]="messageTemplate" [loadingStartRow]="loadingStartRow" [loadingEndRow]="loadingEndRow" (selectedResult)="onSelectedResult($event)" [showstatus]="true" [geographicFilterRegion]="geographicFilterRegion" [showGeographic]="listForm.get('GeoField').value == 'Geographic'" [showNIBINSite]="listForm.get('GeoField').value == 'NIBINSite'" [selectedNIBINSite]="selectedSiteValues" [hideAgencyTag]="hideAgencyTag" [showFA]="listForm.get('OnlyFirearms').value" [showEVID]="listForm.get('OnlyNIBINLeads').value" [dateRangeFilterLabel]="dateRangeFilterLabel"></ness-search-results>
</section>
<p-sidebar #sb (onShow)="onShowSidebar(sb);" (onHide)="clearSidebar()" [(visible)]="showSidebar" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
  <ng-container *ngIf="event$ | async as event">
    <ness-event-detail *ngIf="showEventDetail" #viewEvent (showEventDetail)="showSidebar = showEventDetail = false;" [event]="event" [hasEditPermission]="false" [returnRoute]="{commands: ['/search'], extras: returnRouteNavigationExtras}"></ness-event-detail>
  </ng-container>
  <ng-container *ngIf="crimeGunCustomFields$ | async as gunDetailCustomFields">
    <p-messages key="firearmCrimeGunMsg" [closable]="true" (valueChange)="showSidebar = showFirearmData = false"></p-messages>
    <ng-container *ngIf="hasVirtualRelationToFirearm; else viewfirearm">
      <ng-container *removeIfNoPermission="canEditCrimeGunFirearm; else viewfirearm">
        <ness-crime-gun-firearm *ngIf="showFirearmData" [displayLegacyGunID]="false" [gunDetailCustomFields]="gunDetailCustomFields" [states]="lookupService.usStates$ | async" (onFirearmUpdate)="onFirearmUpdate($event)" (closeFirearmView)="closeFirearmView()" (refreshFirearm)="closeFirearmView()" (refreshTraceData)="showCrimeGunCustomFields(gunDetailCustomFields.FirearmID)"></ness-crime-gun-firearm>
      </ng-container>
     </ng-container>
      <ng-template #viewfirearm>
        <ness-crime-gun-firearm-detail *ngIf="showFirearmData" [gunDetailCustomFields]="gunDetailCustomFields" (closeFirearmView)="closeFirearmView()"></ness-crime-gun-firearm-detail>
      </ng-template>
    </ng-container>
    <p-messages key="nibinCaseDataMsg" [closable]="true" (valueChange)="showSidebar = showNIBINCaseData = false"></p-messages>
    <ness-nibin-case-data *ngIf="showNIBINCaseData" (showDetails)="onShowDetails($event)" (showNIBINCaseData)="showSidebar = showNIBINCaseData = false"></ness-nibin-case-data>
</p-sidebar>
